import React from "react";
import { SvgComponent } from "@commons/Componentes/SvgComponent/SvgComponent";

const Etiqueta = ({ tono, icono, titulo, children }) => (
  <span className={`citrus-gpt-tag citrus-gpt-tag--${tono}`} title={titulo} tabIndex={titulo ? 0 : undefined}>
    {icono && <SvgComponent iconName={icono} width="13px" height="13px" fill="currentColor" />}
    {children}
  </span>
);

/**
 * Un turno del chat. El contenido llega como HTML ya saneado desde el servidor:
 * MarkdownHelper escapa antes de dar formato, así que el modelo no puede inyectar marcado.
 */
export const ChatMensaje = ({ mensaje, puedeRevisar }) => {
  const respuesta = mensaje?.Respuesta;
  const esAsistente = Boolean(mensaje?.EsAsistente);

  return (
    <div className={`citrus-gpt-msg citrus-gpt-msg--${esAsistente ? "asistente" : "usuario"}`}>
      <span className="citrus-gpt-msg__remitente">{mensaje?.Remitente}</span>

      <div
        className="citrus-gpt-msg__burbuja"
        dangerouslySetInnerHTML={{ __html: mensaje?.ContenidoHtml || "" }}
      />

      {esAsistente && respuesta && (
        <>
          <div className="citrus-gpt-msg__meta">
            {respuesta.EsValidada ? (
              <Etiqueta
                tono="validada"
                icono="check"
                titulo="Un experto revisó esta respuesta y la dio por buena."
              >
                Validada{respuesta.ValidadaPor ? ` por ${respuesta.ValidadaPor}` : ""}
              </Etiqueta>
            ) : (
              <Etiqueta
                tono="pendiente"
                titulo="Todavía ningún experto la ha revisado. Verifíquela antes de aplicarla."
              >
                Sin validar
              </Etiqueta>
            )}

            {respuesta.EsRiesgoAlto && (
              <Etiqueta
                tono="riesgo"
                icono="alert"
                titulo="Aplicar esta respuesta podría tener consecuencias importantes si es incorrecta, por ejemplo en contabilidad, inventario o cierres. No significa que esté equivocada; un experto debe validarla antes de aplicar los pasos."
              >
                Riesgo alto
              </Etiqueta>
            )}

            {puedeRevisar && respuesta.Confianza != null && (
              <Etiqueta
                tono="neutra"
                titulo="Qué tan cerca estuvo la documentación recuperada de la pregunta."
              >
                Coincidencia {Number(respuesta.Confianza).toFixed(0)}%
              </Etiqueta>
            )}
          </div>

          {respuesta.EvidenciaInsuficiente && (
            <p className="citrus-gpt-msg__aviso">
              Esta respuesta no tiene respaldo suficiente en la documentación. Valídela con un experto.
            </p>
          )}

          {puedeRevisar && respuesta.Fuentes?.length > 0 && (
            <p className="citrus-gpt-msg__fuentes">
              <strong>Fuentes:</strong> {respuesta.Fuentes.join(", ")}
            </p>
          )}

          {puedeRevisar && respuesta.IdSec > 0 && (
            <a
              className="citrus-gpt-msg__revisar"
              href={`/App/Seguridad/ConocimientoIAEdit?IdSec=${respuesta.IdSec}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Revisar esta respuesta
            </a>
          )}
        </>
      )}
    </div>
  );
};
